import React, { useEffect } from "react";
import PropTypes from "prop-types";

const RegistrationPopup = ({
  onRegistrationClose,
  onRegistrationSuccess,
  baseUrl,
  next,
}) => {
  const receiveMessage = (event) => {
    let message = null;

    try {
      message = JSON.parse(event.data);
    } catch (err) {
      message = event.data;
    }

    if (message === "user.register.out") {
      onRegistrationClose();
    } else if (message === "user.register.success") {
      onRegistrationSuccess();
    }
  };

  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);

    return () => {
      window.removeEventListener("message", receiveMessage, false);
    };
  }, []);

  const ga = window[window["GoogleAnalyticsObject"]];
  const gaMark = ga?.getAll()[0]?.get("linkerParam");

  const params = new URLSearchParams({
    next: next || window.location.href,
    iframe: 1,
    ...(gaMark && { gaMark }),
  });

  const iframeSrc = `https://id.${baseUrl}/register/?${params.toString()}`;

  return (
    <iframe
      title="Registration popup"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 99999,
      }}
      height="100%"
      frameBorder="0"
      scrolling="no"
      width="100%"
      src={iframeSrc}
    />
  );
};

RegistrationPopup.propTypes = {
  baseUrl: PropTypes.string,
  next: PropTypes.string,
  onRegistrationClose: PropTypes.func,
  onRegistrationSuccess: PropTypes.func,
};

export default RegistrationPopup;
